import { createContext, Dispatch, useContext, useEffect, useState } from "react";
import { APISetupUserRunMode, RequestGetUserRunMode } from "./ContextService";


export type RunModType = 'PRODUCTION' | 'TEST'

type RunModContextType = {
		mode: RunModType
		setRunMode: (mode: RunModType) => Promise<void>;
}
export type RunModeContextProviderProps = {
		children: JSX.Element;
}

const STORAGE_KEY = "run_mode"

const RunModeContext = createContext<RunModContextType | undefined>(undefined)

export const RunModeContextProvider = (props: RunModeContextProviderProps) => {

	const [mode, setMode] = useState<RunModType>('PRODUCTION')
	
	const setRunMode = async (newMode: RunModType) => {
		const body: RequestGetUserRunMode = {
			runMode: newMode,
		}

		const response = await APISetupUserRunMode(body)
		if (!response.status) 
		{
			console.error("Failed to sync run mode with backend")
		}

		setMode(newMode);
		sessionStorage.setItem(STORAGE_KEY, newMode)
		window.location.reload()
	}

	useEffect(() => {
		const storedMode = (sessionStorage.getItem(STORAGE_KEY) as RunModType) || "PRODUCTION"

		setMode(storedMode)
		sessionStorage.setItem(STORAGE_KEY, storedMode)

		// Sync backend ONCE on load
		APISetupUserRunMode({ runMode: storedMode }).catch(() =>
			console.error("Failed to sync run mode on init")
		)
	}, [])

	return (
		<RunModeContext.Provider value={{ mode, setRunMode }}>
			{props.children}
		</RunModeContext.Provider>
	)
}

export const useRunMode = () => {
	const context = useContext(RunModeContext)
	if(!context) throw new Error("useTheme must be used within an ThemeProvider")
	return context
}